<template>
    <div data-cy="navbar">
        <div
            class="fixed right-7 top-[52px] z-501 ml-7 md:absolute md:right-20 md:top-14"
        >
            <transition
                enter-active-class="transition duration-200 ease-out"
                enter-from-class="translate-y-1 opacity-0"
                enter-to-class="translate-y-0 opacity-100"
                leave-active-class="transition duration-150 ease-in"
                leave-from-class="translate-y-0 opacity-100"
                leave-to-class="translate-y-1 opacity-0"
            >
                <Announcements
                    v-if="announcementsOpened"
                    v-click-away="closeAnnouncements"
                ></Announcements>
            </transition>
        </div>

        <div
            class="fixed z-500 flex h-14 w-full items-center justify-between bg-gray-800 md:relative md:h-16"
            @click.self="handleCloseSideBarMobile"
        >
            <div class="flex items-center">
                <inertia-link href="/" class="hidden md:block">
                    <div
                        class="flex h-16 w-16 items-center justify-center bg-linear-to-br from-gray-700 to-[#4B5563]"
                    >
                        <svg width="24" height="24" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M80.3379 66.8004V80.263H60.2534V66.8004H80.3379ZM0 66.8004H20.0845V80.263H0V66.8004ZM0.0223161 50.1727V30.1126H20.0845V50.1727H0.0223161ZM60.2534 50.1727V30.1126H20.0845V13.4849H60.2534V30.1126H80.3044V50.1727H60.2534ZM20.0845 50.1727H60.2534V66.8004H20.0845V50.1727ZM0 13.4737V0.0222778H20.0845V13.4849L0 13.4737ZM80.3379 13.4737H60.2534V0.0222778H80.3379V13.4737Z" fill="white"/>
                        </svg>

                    </div>
                </inertia-link>
                <TeamMenu @closeMenuMobile="handleCloseSideBarMobile" />
                <SideBarMobile
                    v-if="globalProps.user.app_type === null || globalProps.user.app_type == 'pro' || globalProps.user.app_type == 'both'"
                    class="overflow-y-scroll"
                    :opened="sideBarMobileOpened"
                    @close="handleCloseSideBarMobile"
                />
                <PluginSideBarMobile
                    v-if="globalProps.user.app_type !== null || globalProps.user.app_type == 'plugin'"
                    class="overflow-y-scroll"
                    :opened="sideBarMobileOpened"
                    @close="handleCloseSideBarMobile"
                />
            </div>

            <div class="items-center hidden mr-6 md:flex">
                <!-- <ShoppingCartButton v-if="globalProps.isAdmin" /> -->

                <inertia-link
                    v-if="globalProps.isAdmin && isInKiosk"
                    :href="route('templates.index')"
                >
                    <div
                        class="mr-6 hidden text-xs font-medium text-white sm:block"
                    >
                        Go Back to App
                    </div>
                </inertia-link>

                <inertia-link
                    v-if="globalProps.isAdmin && !isInKiosk"
                    :href="route('kiosk.dashboard.index')"
                >
                    <div
                        class="mr-6 hidden text-xs font-medium text-white sm:block"
                    >
                        Kiosk
                    </div>
                </inertia-link>

                <a v-if="globalProps.user.app_type === null || globalProps.user.app_type == 'pro' || globalProps.user.app_type == 'both'" href="https://support.topol.io/en/" target="_blank"
                    ><div
                        class="mr-6 hidden text-xs font-medium text-white sm:block"
                    >
                        PRO Documentation
                    </div></a
                >

                <a v-if="globalProps.user.app_type !== null && globalProps.user.app_type === 'plugin'" href="https://docs.topol.io/" target="_blank"
                    ><div
                        class="mr-6 hidden text-xs font-medium text-white sm:block"
                    >
                        Plugin Documentation
                    </div></a
                >

                <div class="h-8 w-px bg-[#364152]"></div>

                <OpenAnnouncementButton
                    data-cy="announcements-menu-button-desktop"
                    :announcements-opened="announcementsOpened"
                    :has-unread-announcements="hasUnreadAnnouncements"
                    @toggle-announcements="toggleAnnouncements"
                ></OpenAnnouncementButton>

                <ProfileMenu class="shrink-0" />
            </div>
            <div class="flex items-center mr-3 sm:mr-6 md:hidden">
                <!-- <ShoppingCartButton v-if="globalProps.isAdmin" /> -->

                <OpenAnnouncementButton
                    data-cy="announcements-menu-button-mobile"
                    :announcements-opened="announcementsOpened"
                    :has-unread-announcements="hasUnreadAnnouncements"
                    @toggle-announcements="toggleAnnouncements"
                ></OpenAnnouncementButton>
                <div
                    class="relative flex h-6 w-6 cursor-pointer items-center justify-center"
                    data-cy="side-menu-mobile-button"
                    @click="handleSideBarMobile"
                >
                    <transition
                        enter-active-class="transition ease-in-out duration-800"
                        enter-from-class="transform opacity-0 scale-10"
                        enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-200 ease-in"
                        leave-from-class="opacity-100"
                        leave-to-class="opacity-0"
                    >
                        <div v-if="!sideBarMobileOpened" class="absolute">
                            <svg
                                width="24"
                                height="16"
                                viewBox="0 0 24 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M0 0H24V2H0V0ZM0 7H24V9H0V7ZM16.32 14H0V16H16.32V14Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </transition>
                    <transition
                        enter-active-class="transition duration-1000 ease-in-out"
                        enter-from-class="transform rotate-180 opacity-0 scale-80"
                        enter-to-class="transform scale-100 rotate-0 opacity-100"
                        leave-active-class="transition duration-100 ease-in"
                        leave-from-class="transform opacity-100"
                        leave-to-class="transform opacity-0"
                    >
                        <div v-if="sideBarMobileOpened" class="absolute">
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M10.7072 9.29299L1.41421 0L0 1.41421L9.29299 10.7072L4.60148e-05 20.0001L1.41426 21.4144L10.7072 12.1214L19.799 21.2132L21.2132 19.799L12.1214 10.7072L21.2132 1.61537L19.799 0.201156L10.7072 9.29299Z"
                                    fill="#FFC000"
                                />
                            </svg>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import ProfileMenu from './ProfileMenu.vue';
import TeamMenu from './TeamMenu.vue';
import OpenAnnouncementButton from './components/OpenAnnouncementButton.vue';
import SideBarMobile from '@components/Navigation/SideBarMobile.vue';
import Announcements from '@/components/Announcements.vue';
import { usePage } from '@inertiajs/vue3';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { computed, ref } from 'vue';
import { route } from 'ziggy-js';
import ICurrentTeam from "@/types/Members/ICurrentTeam";
import IUser from "@/types/Members/IUser";

onMounted(() => {
    getHasUnreadAnnouncements();
});

const hasUnreadAnnouncements = ref(false);
const sideBarMobileOpened = ref(false);
const announcementsOpened = ref(false);

const teamProps = computed(() => globalProps.value.team as ICurrentTeam);
const userProps = computed(() => globalProps.value.user as IUser);
const current = computed(() => {
    if (
        teamProps.value.personal_team &&
        teamProps.value.owner_id === userProps.value.id
    ) {
        return userProps.value;
    }
    return teamProps.value;
});


const globalProps = computed(() => usePage<ITopolPageProps>().props);

const isInKiosk = computed(() => {
    return usePage<ITopolPageProps>().url.startsWith('/kiosk');
});

const handleSideBarMobile = () => {
    sideBarMobileOpened.value = !sideBarMobileOpened.value;
};

const getHasUnreadAnnouncements = async () => {
    try {
        const response = await axios.get(
            route('user.has-unread-announcements.index')
        );
        if (response.data.success) {
            hasUnreadAnnouncements.value = response.data.data;
        }
    } catch (error) {
        return;
    }
};

const toggleAnnouncements = () => {
    if (announcementsOpened.value) {
        announcementsOpened.value = false;
        getHasUnreadAnnouncements();
    } else {
        announcementsOpened.value = true;
    }
};

const closeAnnouncements = () => {
    announcementsOpened.value = false;
    getHasUnreadAnnouncements();
};

const handleCloseSideBarMobile = () => {
    sideBarMobileOpened.value = false;
};
</script>
